// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { EventText3_abstract } from './../abstract/SagaSchema/EventText3_abstract';
export class EventText3 extends EventText3_abstract {}
